import cx from "clsx";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import React from "react";

import styles from "./index.module.scss";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  label: React.ReactNode;
  value: React.ReactNode;
  title?: string;
  slotAfterValue?: React.ReactNode;
};

export default function LabelledValue({
  className,
  style,
  label,
  value,
  title,
  slotAfterValue,
}: Props) {
  return (
    <div
      className={cx(styles.container, className)}
      style={style}
      title={title}
    >
      <Flex.Col gap="4px">
        <Flex.Cell className={styles.label}>{label}</Flex.Cell>
        <Flex.Row gap="8px" alignItems="center">
          <Flex.Cell className={styles.value}>{value}</Flex.Cell>
          {slotAfterValue}
        </Flex.Row>
      </Flex.Col>
    </div>
  );
}
